import PhoneArea from "components/PhonePreview/PhoneArea"
import React from "react"

const ResultPreview = ({ bgImage, label }) => {
  return (
    <PhoneArea>
      <div
        style={{
          backgroundImage: `url(${bgImage})`,
          width: "105%",
          height: "105%",
          backgroundSize: "cover",
          marginLeft: "-5px",
          backgroundPosition: "center center",
          boxShadow: "inset 0 0 0 500px rgb(0 0 0 / 50%)",
        }}
      >
        <p style={{ color: "white", textAlign: "center" }} className="pt-3">
          {label}
        </p>
        <div style={{ textAlign: "center", paddingBlockStart: "2em" }}>
          <img
            src="https://admin.dev.markedprivate.com/app/images/preview/trivia-results.png"
            style={{
              maxWidth: "100%",
              maxHeight: "50%",
            }}
          />
        </div>
      </div>
    </PhoneArea>
  )
}

export default ResultPreview
